module.exports = __webpack_public_path__ + "images/ln11x5.ec4b.png";